import React from "react";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

const ReviewHistoryDashboardShimmer = () => {
  return (
    <>
      <div className="mb_20">
        <ShimmerSimpleGallery card imageHeight={200} row={1} col={1} />
      </div>
    </>
  );
};

export default ReviewHistoryDashboardShimmer;
